import { render } from "./CustomCursor.vue?vue&type=template&id=a485f798&scoped=true"
import script from "./CustomCursor.vue?vue&type=script&lang=js"
export * from "./CustomCursor.vue?vue&type=script&lang=js"

import "./CustomCursor.vue?vue&type=style&index=0&id=a485f798&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a485f798"]])

export default __exports__